import { useEffect, useState } from 'react'
import { useUser } from './auth'
import { Link, useLocation } from 'react-router-dom'
import { Menu, Layout, Dropdown, Space, Badge } from 'antd'
import { getTtiMe } from './lib/api'
import { listAccessRequests } from './carbon/carbonApi'
import MaterialIcon from './components/MaterialIcon'

const { Header } = Layout

function navUserName (user) {
  const rawName = user?.name || user?.display || user?.str || user?.email || 'Account'
  if (!String(rawName).includes('@')) return rawName
  return String(rawName)
    .split('@')[0]
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ') || rawName
}

export default function NavBar () {
  const user = useUser()
  const location = useLocation()
  const [canUseBomValidator, setCanUseBomValidator] = useState(false)
  const [pendingRequests, setPendingRequests] = useState(0)
  const logoSrc = `${process.env.PUBLIC_URL || ''}/img/images.png`
  const selectedKey = location.pathname.startsWith('/projects') || location.pathname.startsWith('/carbon-calculator')
    ? '/projects'
    : location.pathname

  useEffect(() => {
    setCanUseBomValidator(false)
    if (!user) return undefined
    let cancelled = false
    getTtiMe()
      .then((data) => {
        if (!cancelled) {
          setCanUseBomValidator(Boolean(data.is_staff || data.is_superuser))
        }
      })
      .catch(() => {
        if (!cancelled) {
          setCanUseBomValidator(false)
        }
      })
    return () => {
      cancelled = true
    }
  }, [user])

  useEffect(() => {
    if (!user) {
      setPendingRequests(0)
      return undefined
    }
    let cancelled = false
    function refreshRequests () {
      listAccessRequests().then((data) => {
        if (!cancelled) setPendingRequests((data.requests || []).filter((request) => request.can_approve && request.status === 'pending').length)
      }).catch(() => { if (!cancelled) setPendingRequests(0) })
    }
    refreshRequests()
    window.addEventListener('focus', refreshRequests)
    window.addEventListener('project-access-changed', refreshRequests)
    return () => {
      cancelled = true
      window.removeEventListener('focus', refreshRequests)
      window.removeEventListener('project-access-changed', refreshRequests)
    }
  }, [user, location.pathname])

  const leftItems = user
    ? [
        ...(canUseBomValidator && process.env.REACT_APP_SHOW_BOM_VALIDATOR === 'true' ? [{ key: '/bom', label: <Link to='/bom'>BOM Validator</Link> }] : []),
        { key: '/projects', label: <Link to='/projects/grouped'>Projects</Link> },
        { key: '/item-library', label: <Link to='/item-library'>Item Library</Link> }
      ]
    : []

  const accountMenuItems = [
    { key: '/account/profile', icon: <MaterialIcon name='account_circle' />, label: <Link to='/account/profile'>My Profile</Link> }
  ]

  return (
    <Header className='tti-navbar'>
      <Link to='/' className='tti-navbar-brand' aria-current={location.pathname === '/' ? 'page' : undefined}>
        <img src={logoSrc} alt='TTI' />
        <span>Sustainability Tool Kit</span>
      </Link>

      <Menu
        mode='horizontal'
        disabledOverflow
        selectedKeys={[selectedKey]}
        items={leftItems}
        className='tti-navbar-tabs'
      />
      {user
        ? (
          <Dropdown menu={{ items: accountMenuItems }} trigger={['click']} placement='bottomRight'>
            <button className='tti-navbar-user-menu' type='button'>
              <Space size={6}>
                <MaterialIcon name='person' />
                <span>{navUserName(user)}</span>
                <Badge count={pendingRequests} size='small' title={`${pendingRequests} pending access requests`} />
                <MaterialIcon name='keyboard_arrow_down' />
              </Space>
            </button>
          </Dropdown>
          )
        : null}
    </Header>
  )
}
